import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.81 8.186a3.19 3.19 0 0 1-2.103-3.003A3.185 3.185 0 0 1 7.89 2c1.112 0 2.073.54 2.643 1.411 0 0 1.171 2.913-1.441 2.042-1.622-.54.54-2.852 2.492-3.033M8.16 14.943a2.28 2.28 0 0 0 .571-3.213 2.28 2.28 0 0 0-3.213-.57c-.66.45-.99 1.2-.99 1.921 0 0 .51 2.222 1.71.6.752-.99-1.5-1.47-2.732-.78"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m3.146 15.904 18.919-3.093M2.936 7.976l19.129 1.291M15.578 13.802c.45-.36.781-.901.871-1.532.15-1.261-.75-2.402-1.982-2.552-1.261-.15-2.402.75-2.552 1.982a2.28 2.28 0 0 0 1.381 2.372M19.752 7.225a1.772 1.772 0 1 1-3.543 0 1.772 1.772 0 0 1 3.543 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.975 15.213 15.518 22H8.401z"
    />
  </svg>
);
export const BalanceIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
